import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (form.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    try {
      await register(form.name, form.email, form.password, form.phone);
      navigate('/menu');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Join Our Community</h2>
        <p className="auth-subtitle">"For where two or three gather in my name, there am I" - Matthew 18:20</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <div className="auth-input-wrapper">
              <i className="fas fa-user"></i>
              <input type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Your name" />
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <div className="auth-input-wrapper">
              <i className="fas fa-envelope"></i>
              <input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="your@email.com" />
            </div>
          </div>
          <div className="form-group">
            <label>Phone (optional)</label>
            <div className="auth-input-wrapper">
              <i className="fas fa-phone"></i>
              <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="(555) 123-4567" />
            </div>
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="auth-input-wrapper">
              <i className="fas fa-lock"></i>
              <input type="password" name="password" value={form.password} onChange={handleChange} required placeholder="At least 6 characters" />
            </div>
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <div className="auth-input-wrapper">
              <i className="fas fa-shield-alt"></i>
              <input type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} required placeholder="Confirm your password" />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? (
              <><i className="fas fa-spinner fa-spin"></i> Creating Account...</>
            ) : 'Create Account'}
          </button>
        </form>

        <p className="auth-link">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
